module.exports = __webpack_public_path__ + "static/media/Event_Program.fea3e246.pdf";